import { compareAsc, parseISO } from "date-fns";
import { groupBy } from "lodash";

import { AgentChatMessage } from "./agentChatMessage.types";

export function mergeAgentChatMessagesWithRevisions(
  existingMessages: readonly AgentChatMessage[],
  newMessages: readonly AgentChatMessage[],
): AgentChatMessage[] {
  const allMessages = [...existingMessages, ...newMessages];
  const messagesByStaticId = groupBy(allMessages, "staticId");

  return Object.values(messagesByStaticId)
    .map(preserveFirstSeenTimestampOnLatestRevision)
    .sort((a, b) =>
      compareAsc(parseISO(a.createdDate), parseISO(b.createdDate)),
    );
}

function preserveFirstSeenTimestampOnLatestRevision(
  messagesWithSameStaticId: AgentChatMessage[],
): AgentChatMessage {
  const firstMessage = messagesWithSameStaticId.reduce((earliest, current) =>
    compareAsc(parseISO(current.createdDate), parseISO(earliest.createdDate)) <
    0
      ? current
      : earliest,
  );
  const latestMessage = messagesWithSameStaticId.reduce((latest, current) =>
    current.revision >= latest.revision ? current : latest,
  );

  return {
    ...latestMessage,
    createdDate: firstMessage.createdDate,
    initiatedDate: firstMessage.initiatedDate,
  };
}
